import { colors } from '../../styles'

const Toast = {
  baseStyle: {
    width: ['300px', '70%', '30%'],
    maxWidth: '350px',
    minWidth: ['200px', '30%', '240px'],
    height: '63px',
    boxSizing: 'boder-box',
    boxShadow: '0px 2px 26px rgba(82, 215, 0, 0.1)',
    borderRadius: '6px',
  },
  variants: {
    default: {
      border: `1px solid ${colors.primary.base}`,
    },
    action: {
      border: `1px solid ${colors.gray[100]}`,
      width: ['300px', '70%', '100%'],
      maxWidth: '400px',
      minWidth: ['200px', '30%', '25%'],
    },
    gray: {
      width: '100%',
      height: '100%',
      backgroundColor: colors.gray[50],
      border: null,
    },
    dark: {
      bgColor: colors.gray[900],
      border: `1px solid ${colors.primary.base}`,
      boxShadow: '0px 2px 26px rgba(82, 215, 0, 0.1)',
      color: 'white',
      width: '290px',
    },
    report: {
      height: '66px',
      bgColor: colors.gray['50'],
      padding: '12px 24px',
      gap: '99px',
      borderRadius: '6px',
      boxShadow: '0px 2px 26px rgba(82, 215, 0, 0.1)',
      boder: `1px solid ${colors.gray[100]}`,
    },
    cardManagement: {
      width: ['300px', '70%', '15%'],
      maxWidth: '350px',
      minWidth: ['100px', '100px', '150px'],
      textAlign: 'center',
      boxShadow: '0px 12px 16px rgba(0, 0, 0, 0.25);',
      padding: '12px 0px',
      borderRadius: '6px',
      height: '46px',
    },
  },
  defaultProps: {
    variant: 'default',
  },
}

export const ToastComponent = {
  ...Toast,
}
